import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Box, Typography } from '@mui/material'

import { GRTooltip } from '../../../../../components/GRTooltip/GRTooltip'

export const maxTooltipNames = 20

type TagAssignmentCountProps = {
  // Undefined while the data the count comes from hasn't loaded.
  names?: string[]
  title: string
}

export const TagAssignmentCount: FC<TagAssignmentCountProps> = ({ names, title }) => {
  const { t } = useTranslation()
  if (!names) return <>–</>
  if (!names.length) return <>0</>

  const shown = names.slice(0, maxTooltipNames)
  const hiddenCount = names.length - shown.length
  return (
    <GRTooltip
      content={
        <Box>
          <Typography variant="body2" fontWeight="bold" mb={0.5}>
            {title}
          </Typography>
          {shown.map((name, index) => (
            <Typography key={`${name}-${index}`} variant="body2">
              {name}
            </Typography>
          ))}
          {hiddenCount > 0 && (
            <Typography variant="body2" color="text.secondary">
              {t('internal-service-management:tags_and_more', { count: hiddenCount })}
            </Typography>
          )}
        </Box>
      }
    >
      <Typography component="span" tabIndex={0} sx={{ textDecoration: 'underline dotted', cursor: 'default' }}>
        {names.length}
      </Typography>
    </GRTooltip>
  )
}
